import { inject, Injectable } from '@angular/core';
import { ApiService } from '@shared/services/api.service';
import { IOrganisationConfiguration } from '@shared/interfaces/responsible/IOrganisationConfiguration';
import { OrganisationConfigurationUpdate } from '@monorepo/interfaces';

@Injectable({
    providedIn: 'root'
})
export class OrganisationConfigurationService {
    private readonly apiUrl = '/organisation-configuration';

    private readonly apiService = inject(ApiService);

    public getConfigurationById(id: string): Promise<IOrganisationConfiguration> {
        return this.apiService.get(`${this.apiUrl}/${id}`);
    }

    public updateItem(item: IOrganisationConfiguration): Promise<IOrganisationConfiguration> {
        const dto: OrganisationConfigurationUpdate = {
            reportStartDate: item.reportStartDate?.toISOString(),
            reportEndDate: item.reportEndDate?.toISOString(),
            dueDate: item.dueDate?.toISOString(),
            freezeDate: item.freezeDate?.toISOString(),
            selectedTemplate: item?.selectedTemplate,
            inheritedTemplateFromParent: item?.inheritedTemplateFromParent,
            disableCascadingForChildren: item?.disableCascadingForChildren,
            communication: item?.communication
        };
        return this.apiService.patch(`${this.apiUrl}/${item.id}`, dto);
    }

    public inheritDates(id: string): Promise<void> {
        return this.apiService.post(`${this.apiUrl}/inherit-dates/${id}`);
    }
}
